import { Button, Grid, InputLabel, MenuItem, Select, Snackbar, Typography } from '@material-ui/core';
import { ItemDetails as Item, StoreData } from '../../data/store-data';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { CartContext } from '../../store/CartContext';
import qs from 'querystring';

import './ItemDetails.css';
import { CheckoutContext, FlowsOptions } from '../../store/CheckoutContext';

function unescapeHtml(text: string) {
  const elem = document.createElement('textarea');
  elem.innerHTML = text;
  return elem.textContent || '';
}

export default function ItemDetails() {
  const storeData = useMemo(() => new StoreData(), []);
  const query = qs.parse(window?.location.search.replace(/^\?/, ''));
  const params = useParams<any>();
  const [item, setItem] = useState<Item>();
  const [size, setSize] = useState((query.size as string) || 'M');
  const [quantity, setQuantity] = useState(1);
  const [snackOpen, setSnackOpen] = useState(false);

  const { setCart } = useContext(CartContext);
  const { flow } = useContext(CheckoutContext);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (params.listId && params.itemId) {
      storeData.getItem(params.listId, params.itemId).then(data => setItem(data));
    } else {
      console.error('listId or itemId is undefined');
    }
  }, [params, storeData]);

  function addToCart() {
    if (item) {
      storeData.addItemToCart(item, size, quantity);
      setCart(storeData.getCart());
      setSnackOpen(true);
    }
  }

  function handleSnackClose() {
    setSnackOpen(false);
  }

  return (
    <div className="ItemDetails">
      {item && (
        <>
          <Grid container className="container">
            <Grid item xs={12} sm={5}>
              <div className="image-container">
                <img className="item-details-image" src={item.largeImage} alt={item.title} />
              </div>
            </Grid>
            <Grid item xs={12} sm={6} className="content">
              <Typography variant="h5">{item.title}</Typography>
              <Typography variant="body1" color="textSecondary">
                ${item.price.toFixed(2)}
              </Typography>
              <div className="pickers">
                <div className="field-set">
                  <InputLabel className="label" id="sizeLabel">
                    Size
                  </InputLabel>
                  <Select
                    className="input"
                    labelId="sizeLabel"
                    value={size}
                    onChange={event => setSize(event.target.value as string)}
                  >
                    <MenuItem value="XS">XS</MenuItem>
                    <MenuItem value="S">S</MenuItem>
                    <MenuItem value="M">M</MenuItem>
                    <MenuItem value="L">L</MenuItem>
                    <MenuItem value="XL">XL</MenuItem>
                  </Select>
                </div>
                <div className="field-set">
                  <InputLabel className="label" id="quantityLabel">
                    Quantity
                  </InputLabel>
                  <Select
                    className="input"
                    labelId="quantityLabel"
                    value={quantity}
                    onChange={event => setQuantity(Number(event.target.value))}
                  >
                    <MenuItem value="1">1</MenuItem>
                    <MenuItem value="2">2</MenuItem>
                    <MenuItem value="3">3</MenuItem>
                    <MenuItem value="4">4</MenuItem>
                    <MenuItem value="5">5</MenuItem>
                  </Select>
                </div>
              </div>
              <div className="description">
                <Typography variant="h6">Description</Typography>
                <Typography variant="body2" component="div" color="textSecondary">
                  <div dangerouslySetInnerHTML={{ __html: unescapeHtml(item.description) }} />
                </Typography>
              </div>
              <div className="buttons">
                <Button variant="outlined" onClick={addToCart}>
                  Add to Cart
                </Button>
              </div>
            </Grid>
          </Grid>
          <Snackbar
            ContentProps={{
              className: 'snackbar-info',
            }}
            open={snackOpen}
            autoHideDuration={5000}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            onClose={handleSnackClose}
            message={`${item.title} added to cart.`}
            action={
              <>
                <Button onClick={handleSnackClose}>Dismiss</Button>
                <Button
                  onClick={() => {
                    if (location.pathname.includes('demo')) {
                      navigate('/demo/cart');
                    } else {
                      navigate('/cart');
                    }
                  }}
                >
                  View cart
                </Button>
                {/*<Button onClick={() => navigate('/checkout')}>Checkout</Button>*/}
                <Button
                  // onClick={() =>
                  //   navigate(location.pathname.includes('demo') ? `/demo/checkout-iframe` : '/checkout-iframe')
                  // }
                  onClick={() => {
                    if (location.pathname.includes('demo')) {
                      navigate('/demo/checkout-iframe');
                    } else {
                      switch (flow) {
                        case FlowsOptions.terminal:
                          navigate('/terminal');
                          break;
                        case FlowsOptions.steps:
                          navigate('/checkout-steps');
                          break;
                        case FlowsOptions.withoutOrderId:
                          navigate('/checkout-iframe-without-order-id');
                          break;
                        case FlowsOptions.iframe:
                          navigate('/checkout-iframe');
                          break;
                        default:
                          navigate('/checkout-iframe');
                          break;
                      }
                    }
                  }}
                >
                  Checkout
                </Button>
                {/*<Button onClick={() => navigate('/checkout')}>Checkout</Button>*/}
                {/*<Button onClick={() => navigate('/checkout-hosted-fields')}>Hosted Fields</Button>*/}
              </>
            }
          />
        </>
      )}
    </div>
  );
}
